import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import { Button, BUTTON_LAYOUTS, Paper } from 'components/UI'
// context
import { DetailsModalActionsContext } from 'containers/MinimizedObjectivesList/layers/Business/DetailsModalActions'
import { SelectedPlanItemsContext } from 'containers/SubPlan/layers/BL/SelectedItems'
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// themes
import { colors } from 'themes'
import BackIcon from '@mui/icons-material/NavigateBefore'
import { AddIcon as AddIconOrigin, LinkIcon, RemoveIcon as RemoveIconOrigin } from 'themes/views/objectivesList'
// types
import { IPlan } from 'types/graphql'
import { TSourceItem } from 'containers/MinimizedObjectivesList/layers/Business/utils'
// utils
import get from 'lodash/get'

// styled
const RemoveIcon = styled(RemoveIconOrigin)`
  > path {
    fill: ${colors.purple800};
  }
`

const AddIcon = styled(AddIconOrigin)`
  > path {
    fill: ${colors.purple800};
  }
`

const BottomPaper = styled(Paper)`
  && {
    display: flex;
    gap: 6px;
    position: fixed;
    bottom: 0;
    background: ${colors.gray200};
    padding: 10px 8px;
    width: 600px;
    right: 0;
    z-index: 9999999;
  }
`

// types
interface IIncomingProps {
  entity: any
  hideModal: () => void
  isSubPlan: boolean
  plan: IPlan
  sourceItems?: TSourceItem[]
}

const AdditionalModalActions: React.FunctionComponent<IIncomingProps> = ({
  entity,
  hideModal,
  isSubPlan,
  plan,
  sourceItems
}) => {
  const router = useRouter()

  const { selectedPlanItems, selectPlanItem } = React.useContext(SelectedPlanItemsContext)
  const { enableLinkingMode } = React.useContext(LinkingModeContext)
  const { handleAddToSubPlan, handleRemoveFromSubPlan, handleSetShowModalActions } =
    React.useContext(DetailsModalActionsContext)

  const { planAddItemsFromParentPlan } = plan.currentPermissions

  // constants
  const planItem = entity.planItems.data.find(({ planId }) => planId === router.query.parentId)
  const referencedPlanItem = entity.planItems.data.find(({ planId }) => planId === router.query.id)
  const isSelected = selectedPlanItems.some(({ id }) => id === planItem.id)

  // methods
  const handleAddButtonClick = () => {
    handleAddToSubPlan({ ...entity, planItem, sourceItems })
    selectPlanItem({ id: planItem.id })
  }

  const handleRemoveButtonClick = () => {
    handleRemoveFromSubPlan(planItem.id, get(referencedPlanItem, 'id'))
  }

  const onLinkButtonClick = () => {
    enableLinkingMode(entity.id, entity.planId, entity.description, entity.entityType)
    handleSetShowModalActions(false)
    hideModal()
  }

  return (
    <BottomPaper square>
      <Button layout={BUTTON_LAYOUTS.WHITE} type='button' onClick={hideModal}>
        <BackIcon />
      </Button>
      {!isSelected && !isSubPlan && planAddItemsFromParentPlan && (
        <Button layout={BUTTON_LAYOUTS.WHITE} type='button' onClick={handleAddButtonClick}>
          <AddIcon /> Add to sub plan
        </Button>
      )}
      <Button layout={BUTTON_LAYOUTS.WHITE} type='button' onClick={handleRemoveButtonClick}>
        <RemoveIcon /> Remove from sub plan
      </Button>
      <Button layout={BUTTON_LAYOUTS.PURPLE} type='button' onClick={onLinkButtonClick}>
        <LinkIcon />
        Link
      </Button>
    </BottomPaper>
  )
}

export default AdditionalModalActions
